import type { Verification } from '../useVerification';
import { Modal } from './Modal';

export function VerifyModal({ verification, commitmentCount, onClose }: { verification: Verification; commitmentCount: number; onClose: () => void }) {
  const failures = verification.checks.filter(c => !c.ok).length;
  return (
    <Modal title="Deal verification" onClose={onClose} wide>
      <p>{verification.checks.length} of {commitmentCount} cards opened; {failures === 0 ? 'every opening matches its commitment.' : `${failures} mismatch${failures === 1 ? '' : 'es'}.`}</p>
      <ul className="verify-list">
        {verification.checks.map(c => (
          <li key={c.position} className={c.ok ? 'ok' : 'bad'}>
            <span className="pos">#{c.position}</span>
            <code>{c.preimage}</code>
            <code>{c.computed}</code>
            {c.ok ? <span className="muted">matches</span> : <span>expected <code>{c.expected}</code></span>}
          </li>
        ))}
      </ul>
    </Modal>
  );
}
